const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://coresell.ir').replace(/\/$/, '');

export const landingSeo = {
  siteUrl: SITE_URL,
  siteName: 'کورسل',
  brandName: 'CoreSell',
  locale: 'fa_IR',

  title: 'کورسل (CoreSell) | مدیریت موجودی و همگام‌سازی هوشمند قیمت دیجی‌کالا، باسلام و ووکامرس',
  titleTemplate: '%s | کورسل',

  description:
    'کورسل نرم‌افزار هوشمند مدیریت موجودی و قیمت‌گذاری چند کاناله برای فروشندگان آنلاین است. موجودی و قیمت دیجی‌کالا، باسلام و سایت شخصی (ووکامرس) را در لحظه یکسان کنید، ورود اکسل داشته باشید و از جریمه لغو سفارش جلوگیری کنید. توسعه و پشتیبانی: altostudio.ir',

  keywords: [
    'مدیریت موجودی آنلاین‌شاپ',
    'همگام‌سازی موجودی',
    'همگام‌سازی قیمت',
    'قیمت‌گذاری چند کاناله',
    'درصد کمیسیون دیجی‌کالا',
    'موجودی چند کاناله',
    'انبار مرکزی',
    'دیجی‌کالا',
    'باسلام',
    'ووکامرس',
    'افزونه وردپرس',
    'ورود اکسل انبار',
    'فروش چند کاناله',
    'جریمه لغو سفارش دیجی‌کالا',
    'موجودی منفی',
    'نرم‌افزار انبارداری آنلاین',
    'کورسل',
    'CoreSell',
    'آلتو استودیو',
    'altostudio.ir',
    'اتصال پنل فروشندگان',
    'به‌روزرسانی خودکار موجودی',
    'مدیریت تنوع کالا',
    'همگام‌سازی لحظه‌ای موجودی',
  ].join(', '),

  ogImage: `${SITE_URL}/sid.png`,
  ogImageAlt: 'لوگوی کورسل — سیستم مدیریت یکپارچه موجودی و قیمت آنلاین‌شاپ‌ها',
  ogType: 'website',
  twitterCard: 'summary_large_image',

  author: 'CoreSell & Alto Studio',
  robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',

  canonicalPath: '/',

  howItWorks: [
    {
      step: 1,
      title: 'اتصال فروشگاه‌ها',
      description:
        'حساب دیجی‌کالا، باسلام و سایت شخصی یا ووکامرس (با افزونه اختصاصی) را در چند دقیقه به کورسل متصل کنید.',
    },
    {
      step: 2,
      title: 'تعریف انبار مرکزی و قیمت‌گذاری',
      description:
        'محصولات، تنوع‌های رنگ/سایز و قیمت پایه را ثبت کنید و درصد افزایش یا کاهش اختصاصی هر درگاه را تنظیم نمایید (یا از فایل اکسل ایمپورت کنید).',
    },
    {
      step: 3,
      title: 'همگام‌سازی خودکار و در لحظه',
      description:
        'با هر فروش در هر درگاه یا تغییر در انبار، سیستم در کمتر از یک ثانیه موجودی و قیمت را در تمام فروشگاه‌های متصل به‌روزرسانی می‌کند.',
    },
    {
      step: 4,
      title: 'کنترل، گزارش و توسعه',
      description:
        'از داشبورد لحظه‌ای، لاگ خطاها و گزارش‌های دقیق مطلع شوید و از پشتیبانی تخصصی آلتو استودیو (altostudio.ir) بهره‌مند گردید.',
    },
  ],

  faq: [
    {
      question: 'کورسل چیست و برای چه کسانی مناسب است؟',
      answer:
        'کورسل یک سامانه جامع مدیریت موجودی و قیمت چند کاناله است که برای فروشندگان آنلاین طراحی شده است؛ کسانی که همزمان در دیجی‌کالا، باسلام و سایت شخصی خود می‌فروشند و می‌خواهند موجودی و قیمت همه کانال‌ها همیشه دقیق و بدون مغایرت بماند.',
    },
    {
      question: 'همگام‌سازی قیمت کالاها در درگاه‌ها چگونه کار می‌کند؟',
      answer:
        'شما می‌توانید برای هر محصول یک قیمت پایه در انبار مرکزی تعیین کنید و برای درگاه‌هایی مثل دیجی‌کالا یا باسلام درصد افزایش مجزا (مثلاً +۱۵٪ جهت پوشش کمیسیون و هزینه‌ها) در نظر بگیرید. با تغییر قیمت پایه، کورسل قیمت هدف هر درگاه را به صورت خودکار محاسبه و به پلتفرم ارسال می‌کند.',
    },
    {
      question: 'آیا کورسل با پنل جدید فروشندگان دیجی‌کالا سازگار است؟',
      answer:
        'بله. کورسل با معماری صف‌های دسته‌ای به APIهای رسمی پنل جدید فروشندگان دیجی‌کالا متصل است و موجودی و قیمت را بدون ایجاد تداخل یا تاخیر همگام می‌کند.',
    },
    {
      question: 'چطور از جریمه لغو سفارش در دیجی‌کالا جلوگیری می‌کنم؟',
      answer:
        'وقتی موجودی در همه کانال‌ها دقیق و همزمان باشد، احتمال فروش کالایی که در انبار موجود نیست صفر می‌شود. کورسل با کاهش موجودی در تمام پلتفرم‌ها بلافاصله پس از هر فروش، ریسک لغو سفارش و جریمه را به طور کامل از بین می‌برد.',
    },
    {
      question: 'آیا باسلام و ووکامرس هم پشتیبانی می‌شوند؟',
      answer:
        'بله. علاوه بر دیجی‌کالا، می‌توانید باسلام و فروشگاه ووکامرس (از طریق افزونه اختصاصی یا وب‌هوک) را به انبار مرکزی کورسل متصل کنید.',
    },
    {
      question: 'آیا امکان ورود و خروج دسته‌ای موجودی با فایل اکسل وجود دارد؟',
      answer:
        'بله. ماژول انبارداری پیشرفته کورسل به شما اجازه می‌دهد فایل اکسل موجودی انبار را بارگذاری کنید تا موجودی هزاران کالا همزمان ثبت و به درگاه‌های متصل منتقل شود.',
    },
    {
      question: 'همگام‌سازی موجودی چقدر طول می‌کشد؟',
      answer:
        'همگام‌سازی در کورسل لحظه‌ای و معمولاً در کمتر از یک ثانیه انجام می‌شود تا مشتریان در هیچ کانالی کالای ناموجود نخرند.',
    },
    {
      question: 'آیا می‌توانم تنوع رنگ و سایز کالا را مدیریت کنم؟',
      answer:
        'بله. کورسل از تنوع‌های چندسطحی کالا (واریانت، رنگ، سایز و گارانتی) پشتیبانی می‌کند و موجودی و درصد قیمت هر تنوع را به‌صورت مجزا در همه فروشگاه‌ها هماهنگ می‌کند.',
    },
    {
      question: 'چگونه می‌توانم با تیم پشتیبانی و سازندگان کورسل تماس بگیرم؟',
      answer:
        'کورسل توسط آلتو استودیو طراحی و پشتیبانی می‌شود. برای مشاوره، سفارشی‌سازی و ارتباط می‌توانید به وب‌سایت altostudio.ir مراجعه فرمایید یا از بخش تماس لندینگ اقدام فرمایید.',
    },
    {
      question: 'اطلاعات اکانت فروشگاه‌های من امن است؟',
      answer:
        'کورسل با رعایت استانداردهای امنیتی، اطلاعات اتصال و توکن‌های فروشگاهی شما را محافظت می‌کند. دسترسی‌ها فقط برای همگام‌سازی مجاز موجودی و قیمت استفاده می‌شوند.',
    },
  ],

  seoArticle: {
    heading: 'مدیریت یکپارچه موجودی و قیمت‌گذاری چند کاناله با کورسل (توسعه‌یافته در آلتو استودیو)',
    paragraphs: [
      'فروش همزمان در دیجی‌کالا، باسلام و سایت شخصی فرصت بزرگی برای رشد درآمد است؛ اما بدون سیستم یکپارچه، مدیریت موجودی و قیمت‌گذاری به یکی از پرهزینه‌ترین و استرس‌زاترین بخش‌های کسب‌وکار تبدیل می‌شود. هر فروش در یک کانال باید دستی در بقیه پلتفرم‌ها اعمال شود و نوسانات قیمت کالاها ساعت‌ها وقت تیم را تلف می‌کند.',
      'کورسل (CoreSell) که توسط آلتو استودیو (altostudio.ir) توسعه یافته است، پاسخی جامع به این چالش‌هاست: یک انبار مرکزی هوشمند که موجودی و قیمت تمام فروشگاه‌های شما را در لحظه همگام می‌کند. به محض ثبت سفارش در هر کانال، موجودی همان کالا — با در نظر گرفتن رنگ، سایز و تنوع — در سایر پلتفرم‌ها به‌روز می‌شود.',
      'همچنین با سیستم قیمت‌گذاری پویا، کافی است قیمت پایه محصول را تغییر دهید تا قیمت در دیجی‌کالا، باسلام و سایت با در نظر گرفتن درصدهای کارمزد محاسبه و اعمال شوند. قابلیت ورود فایل اکسل انبارداری، اتصال به افزونه ووکامرس و پردازش فوق‌سریع در صف‌های توزیع‌شده، کورسل را به انتخابی بی‌رقیب تبدیل کرده است.',
      'اگر به‌دنبال نرم‌افزار مدیریت موجودی و قیمت آنلاین‌شاپ، جلوگیری از جریمه لغو سفارش دیجی‌کالا یا یکپارچه‌سازی سیستم‌های فروشگاهی هستید، کورسل همراه مطمئن کسب‌وکار آنلاین شماست. جهت مشاوره و پشتیبانی به altostudio.ir مراجعه نمایید.',
    ],
  },
};

export function getCanonicalUrl(path = '/') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}/#${normalizedPath === '/' ? '/' : normalizedPath}`;
}

export function getStructuredData() {
  const { siteUrl, siteName, brandName, description, ogImage, faq } = landingSeo;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: siteName,
        alternateName: brandName,
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: ogImage,
        },
        description,
        inLanguage: 'fa',
      },
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        name: siteName,
        alternateName: brandName,
        url: siteUrl,
        description,
        inLanguage: 'fa-IR',
        publisher: { '@id': `${siteUrl}/#organization` },
      },
      {
        '@type': 'SoftwareApplication',
        '@id': `${siteUrl}/#software`,
        name: `${siteName} (${brandName})`,
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        url: siteUrl,
        description,
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'IRR',
          description: 'امکان شروع استفاده رایگان',
        },
        featureList: [
          'همگام‌سازی لحظه‌ای موجودی',
          'اتصال دیجی‌کالا، باسلام و ووکامرس',
          'انبار مرکزی چند کاناله',
          'پشتیبانی از تنوع رنگ و سایز',
          'گزارش سفارش و لاگ همگام‌سازی',
        ],
        inLanguage: 'fa',
      },
      {
        '@type': 'FAQPage',
        '@id': `${siteUrl}/#faq`,
        mainEntity: faq.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ],
  };
}
